module.exports = __webpack_public_path__ + "img/icon_pro_base.ff13f446.png";